export const TRANSFER_ACCOUNTS_FORM = 'TRANSFER_ACCOUNTS_FORM';
export const TRANSFER_SEARCH_FORM = 'TRANSFER_SEARCH_FORM';

export const DIALOG_NAME = {
  CONFIRM_TRANSFER: 'CONFIRM_TRANSFER',
};
